import React, { useState } from 'react';
import { Modal, Button, Tabs, Tab } from 'react-bootstrap';
import { useAuth } from '../../Context/auth'; // Adjust path if necessary
import './TermsModal.css';

const TermsModal = ({ show }) => {
    const { currentUser } = useAuth();
    const [loading, setLoading] = useState(false);
    const [key, setKey] = useState('terms');

    const handleAccept = async () => {
        setLoading(true);
        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;

            const response = await fetch(`${API_URL}/api/users/accept-terms`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error('Falha ao aceitar os termos.');
            }

            // Reload page to refresh context (cleanest way)
            window.location.reload();

        } catch (error) {
            console.error(error);
            alert('Erro ao aceitar termos. Tente novamente.');
            setLoading(false);
        }
    };

    return (
        <Modal
            show={show}
            backdrop="static"
            keyboard={false}
            size="lg"
            centered
        >
            <Modal.Header>
                <Modal.Title>Termos e Privacidade - R6 ERP</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                <Tabs
                    id="terms-tabs"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className="mb-3"
                >
                    <Tab eventKey="terms" title="Termos de Uso">
                        <h5>TERMOS E CONDIÇÕES DE USO DO SISTEMA R6 ERP</h5>
                        <p><strong>Última atualização:</strong> 06 de Janeiro de 2026</p>

                        <p>Este Termo de Uso rege a relação entre <strong>LATECH SOLUCOES LTDA</strong>, doravante denominada <strong>LICENCIANTE</strong>, e a pessoa física ou jurídica que utiliza o sistema R6 ERP, doravante denominada <strong>LICENCIADO</strong>.</p>
                        <p>Ao acessar ou utilizar o sistema, o LICENCIADO concorda com todas as condições abaixo.</p>

                        <h6>1. DO OBJETO</h6>
                        <p>1.1. A LICENCIANTE concede ao LICENCIADO uma licença de uso não exclusiva, intransferível e revogável do software <strong>R6 ERP</strong> ("Sistema"), para fins de gestão empresarial.</p>

                        <h6>2. DAS RESPONSABILIDADES DA LICENCIANTE</h6>
                        <p>2.1. Manter o Sistema disponível, ressalvadas interrupções para manutenção ou motivos de força maior.</p>
                        <p>2.2. Garantir o sigilo e segurança dos dados inseridos pelo LICENCIADO, conforme a LGPD (Lei Geral de Proteção de Dados).</p>
                        <p>2.3. Prestar suporte técnico para correção de falhas do sistema ("bugs"), não incluindo consultoria de negócios ou customizações específicas não contratadas.</p>

                        <h6>3. DAS RESPONSABILIDADES DO LICENCIADO</h6>
                        <p>3.1. Utilizar o sistema conforme sua finalidade, não inserindo conteúdo ilícito ou malicioso.</p>
                        <p>3.2. Manter a confidencialidade de suas senhas de acesso. Toda ação realizada com a senha do LICENCIADO será de sua responsabilidade.</p>
                        <p>3.3. Não tentar realizar engenharia reversa, copiar ou revender o Sistema.</p>

                        <h6>4. DA LIMITAÇÃO DE RESPONSABILIDADE</h6>
                        <p>4.1. O Sistema é fornecido "no estado em que se encontra" ("as is"). A LICENCIANTE não garante que o software atenderá a todas as necessidades específicas do LICENCIADO.</p>
                        <p>4.2. A LICENCIANTE não se responsabiliza por prejuízos financeiros, perda de lucros ou danos indiretos decorrentes do uso ou da impossibilidade de uso do sistema, exceto em casos de dolo comprovado.</p>

                        <h6>5. DOS DADOS E PRIVACIDADE</h6>
                        <p>5.1. Os dados inseridos pertencem ao LICENCIADO. A LICENCIANTE pode utilizar dados agregados e anônimos para melhorias estatísticas do sistema.</p>

                        <h6>6. DO CANCELAMENTO</h6>
                        <p>6.1. O acesso poderá ser bloqueado em caso de inadimplência (se aplicável) ou violação destes termos.</p>
                        <p>6.2. O LICENCIADO pode solicitar o cancelamento e a exportação de seus dados a qualquer momento.</p>

                        <h6>7. DO FORO</h6>
                        <p>7.1. Fica eleito o foro da comarca de <strong>Nova Serrana/MG</strong> para dirimir questões deste contrato via digital.</p>
                    </Tab>
                    <Tab eventKey="privacy" title="Política de Privacidade">
                        <h5>POLÍTICA DE PRIVACIDADE - R6 ERP</h5>
                        <p><strong>Última atualização:</strong> 06 de Janeiro de 2026</p>

                        <p>A <strong>LATECH SOLUCOES LTDA</strong> leva a sua privacidade a sério. Esta Política de Privacidade descreve como coletamos, usamos e protegemos as informações pessoais de usuários do sistema <strong>R6 ERP</strong>.</p>

                        <h6>1. INFORMAÇÕES QUE COLETAMOS</h6>
                        <p>Coletamos os seguintes tipos de informações para fornecer e melhorar nosso serviço:</p>
                        <ul>
                            <li><strong>Informações da Conta:</strong> Nome, e-mail, telefone e CPF/CNPJ para cadastro e faturamento.</li>
                            <li><strong>Dados Inseridos no Sistema:</strong> O R6 ERP é uma ferramenta de gestão. Nós armazenamos, <strong>mas não monitoramos nem compartilhamos</strong>, os dados de clientes, produtos, vendas e financeiro que você insere no sistema.</li>
                            <li><strong>Dados de Uso (Logs):</strong> Coletamos logs de acesso (Endereço IP, Navegador, Data a Hora) para fins de segurança e auditoria.</li>
                        </ul>

                        <h6>2. COMO USAMOS SEUS DADOS</h6>
                        <p>Utilizamos seus dados para:</p>
                        <ul>
                            <li>Prover o acesso ao sistema e suas funcionalidades.</li>
                            <li>Processar pagamentos e enviar notas fiscais do uso do software.</li>
                            <li>Enviar avisos importantes sobre o sistema.</li>
                            <li>Cumprir obrigações legais.</li>
                        </ul>

                        <h6>3. COMPARTILHAMENTO DE DADOS</h6>
                        <p><strong>Não vendemos seus dados para terceiros.</strong> Podemos compartilhar dados estritamente necessários com processadores de pagamento e serviços de hospedagem.</p>

                        <h6>4. SEGURANÇA</h6>
                        <p>Adotamos medidas técnicas (criptografia, firewalls) para proteger seus dados. Recomendamos que você utilize senhas fortes.</p>

                        <h6>5. SEUS DIREITOS (LGPD)</h6>
                        <p>Você tem direito a acessar, corrigir e solicitar a exclusão de seus dados pessoais, conforme a LGPD.</p>

                        <h6>6. CONTATO</h6>
                        <p>Dúvidas? Entre em contato conosco:</p>
                        <p><strong>E-mail:</strong> contato.r6erp@gmail.com</p>
                        <p><strong>Whatsapp:</strong> (37) 99982-6905</p>
                    </Tab>
                </Tabs>
            </Modal.Body>
            <Modal.Footer>
                <div className="w-100 d-flex justify-content-end align-items-center">
                    <Button variant="primary" onClick={handleAccept} disabled={loading}>
                        {loading ? 'Processando...' : 'Li e Aceito os Termos e a Política'}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default TermsModal;
